import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  authService,
  IndividualRole,
  removeApiResponseInterceptor,
  useToast,
} from '@aslanpay/portal-common-lib';

import {
  usePhoneVerificationStore,
  useAuthenticationStore,
  useOnboardingStore,
  useImportEmployeesStore,
  useRewardFlowStore,
} from 'app/store';
import { clearActiveLoginContext } from 'app/constants/authentication';

function resetAllStores() {
  useAuthenticationStore.getState().resetAuthenticationData();
  useOnboardingStore.getState().resetOnboardingData();
  useImportEmployeesStore.getState().resetFileUploadData();
  useImportEmployeesStore.getState().resetImportEmployeesData();
  usePhoneVerificationStore.getState().resetPhoneVerificationData();
  useRewardFlowStore.getState().resetRewardFlowData();
}

const useSignOut = (role: IndividualRole | undefined = undefined) => {
  const queryClient = useQueryClient();

  const toast = useToast();

  return useMutation<unknown, Error>(
    () => {
      // Hosted-UI sign-out redirects before its promise resolves, so this cannot wait for onSuccess.
      clearActiveLoginContext();
      return authService.signOutAll();
    },
    {
      onSuccess: () => {
        removeApiResponseInterceptor();
        queryClient.resetQueries({ queryKey: ['getAuthenticatedUser'] });

        // Reset all zustand stores to their initial state
        resetAllStores();

        // TODO: Temporarily signing out when not signed in as an COMPANY_ADMIN
        if (role === 'ASLAN_ADMIN') {
          toast({
            position: 'top-right',
            status: 'error',
            title: 'Access denied',
            description: 'You cannot sign in on the client portal as an Aslan Admin!',
          });
        }
      },
    }
  );
};

export default useSignOut;
